import { create } from 'zustand';
import { toast } from 'react-toastify';
import { getDeviceUpdatePolicies, updateAllDevicesPolicy, updateDevicePolicyById, updateDeviceTestFlag } from '../../../api/api';

export const useFirmwarePoliciesStore = create((set) => ({
  data: [],
  total: 0,
  firmwareVersions: [],
  isLoading: false,
  error: null,
  togglingId: null,

  fetchPolicies: async ({ page, count, sortBy, sortOrder, serialNumber } = {}) => {
    set({ isLoading: true, error: null });

    await getDeviceUpdatePolicies({
      page,
      count,
      sortBy,
      sortOrder,
      serialNumber,
      dataCb: (res) => {
        set({
          data: res?.items ?? [],
          total: res?.count ?? 0,
          firmwareVersions: res?.firmware_versions ?? [],
          isLoading: false,
        });
      },
      errCb: (err) => {
        set({ error: err, isLoading: false });
      },
    });
  },

  togglePolicy: async ({ id, field, value }) => {
    set({ togglingId: id });

    try {
      await updateDevicePolicyById({
        id,
        body: { [field]: value },
      });
      set((state) => ({
        data: state.data.map((item) => (item.device_id === id ? { ...item, [field]: value } : item)),
        togglingId: null,
      }));
      toast.success('Настройки обновлены');
    } catch (err) {
      set({ togglingId: null });
      toast.error(err?.response?.data?.error || 'Не удалось обновить настройки');
    }
  },

  toggleTestDevice: async ({ id, value }) => {
    set({ togglingId: id });

    try {
      await updateDeviceTestFlag({ id, isTestDevice: value });
      set((state) => ({
        data: state.data.map((item) => (item.device_id === id ? { ...item, is_test_device: value } : item)),
        togglingId: null,
      }));
      toast.success(value ? 'Устройство отмечено как тестовое' : 'Отметка «тестовый» снята');
    } catch (err) {
      set({ togglingId: null });
      toast.error(err?.response?.data?.error || 'Не удалось изменить отметку');
    }
  },

  updateAllDevices: async (isUpdateAllowed) => {
    try {
      await updateAllDevicesPolicy({
        body: { is_update_allowed: isUpdateAllowed },
      });
      set((state) => ({
        data: state.data.map((item) => ({ ...item, is_update_allowed: isUpdateAllowed })),
      }));
      toast.success(isUpdateAllowed ? 'Обновления разрешены для всех устройств' : 'Обновления запрещены для всех устройств');
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Не удалось применить настройки');
    }
  },
}));
